import React from "react";
import { Switch, Route } from "react-router-dom";

import asyncComponent from "../AsyncComponent";

import {
  REVIEW,
  APPLY,
  DECLINE,
  JOB_DESCRIPTION,
} from "../components/public/candidate_invitation/constants";

const AsyncStyleGuide = asyncComponent(() =>
  import(
    /* webpackChunkName: "style-guide" */
    "../components/public/StyleGuide"
  ));

const AsyncFormValidations = asyncComponent(() =>
  import(
    /* webpackChunkName: "form-validations" */
    "../components/public/FormValidations"
  ));

const AsyncTeammateInvitation = asyncComponent(() =>
  import(
    /* webpackChunkName: "teammate-invitation" */
    "../components/public/teammate_invitation/TeammateInvitation"
  ));

const AsyncRecruiterRegistration = asyncComponent(() =>
  import(
    /* webpackChunkName: "recruiter-registration" */
    "../components/public/recruiter_registration/RecruiterRegistration"
  ));

const AsyncEmployerVMSRegistration = asyncComponent(() =>
  import(
    /* webpackChunkName: "employer-registration" */
    "../components/public/employer_registration/EmployerVMSRegistration"
  ));

const AsyncEmployerRegistration = asyncComponent(() =>
  import(
    /* webpackChunkName: "employer-registration" */
    "../components/public/employer_registration/EmployerRegistration"
  ));

const AsyncEmployerProvideBillingInfo = asyncComponent(() =>
  import(
    /* webpackChunkName: "employer-biling-info" */
    "../components/public/employer_provide_billing_info/EmployerProvideBillingInfo"
  ));

const Async404Error = asyncComponent(() =>
  import(
    /* webpackChunkName: "general-404-error" */
    "../components/General/404Error"
  ));

const AsyncCandidateInvitation = asyncComponent(() =>
  import(
    /* webpackChunkName: "candidate-invitation-review" */
    "../components/public/candidate_invitation/CandidateInvitation"
  ));

const candidateInviteToken = ":token([0-9a-f]{32})";
const candidateInviteSectionParams = `:section(^$|${REVIEW}|${APPLY}|${DECLINE}|${JOB_DESCRIPTION}|closed|wrong-turn)`;

function PublicRoutes() {
  return (
    <Switch>
      {/* Styleguides */}
      <Route
        exact
        path="/public/styleguide/validations"
        component={AsyncFormValidations}
      />
      <Route
        exact
        path="/public/styleguide"
        component={AsyncStyleGuide}
      />
      {/* Candidate Invitation */}
      {/* we can probably delete this in the future. i just added it for the transition
      period between the old and new candidate invitation url */}
      <Route
        exact
        path={`/public/temp_candidate_invitation/${candidateInviteToken}/${candidateInviteSectionParams}?`}
        component={AsyncCandidateInvitation}
      />
      <Route
        exact
        path={`/public/invite/${candidateInviteToken}/${candidateInviteSectionParams}?`}
        component={AsyncCandidateInvitation}
      />,
      {/* Teammate Invitation */}
      <Route
        exact
        path="/public/sign-up/:token"
        component={AsyncTeammateInvitation}
      />
      {/* Legacy Agency Activation */}
      <Route
        exact
        path="/public/legacy-agency-activation/:legacy_invitation_id"
        component={AsyncRecruiterRegistration}
      />
      {/* Recruiter Registration */}
      <Route
        exact
        path="/public/(agency-registration|talk-agency-registration)"
        component={AsyncRecruiterRegistration}
      />
      {/* Employer Registration */}
      <Route
        exact
        path="/public/employer-registration"
        component={AsyncEmployerVMSRegistration}
      />
      {/* Employer Registration */}
      <Route
        exact
        path="/public/(employer-direct-registration|talk-employer-registration)"
        component={AsyncEmployerRegistration}
      />
      {/* Employer Provide Billing Info */}
      <Route
        exact
        path="/public/provide-billing-info/:token"
        component={AsyncEmployerProvideBillingInfo}
      />
      <Route component={Async404Error} />
    </Switch>
  );
}

export default PublicRoutes;
